// extracted by mini-css-extract-plugin
module.exports = {"sun":"styles_sun__WJ1VG","loading-wheel":"styles_loading-wheel__0CaJ_"};